import React from 'react'

import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'

import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbSelect from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_select'
import DfbInput from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input'
import DfbParagraph from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph'
import DfbInputTextarea from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input_textarea'
import MDefaultform from '../m_defaultForm'
import { extractFields } from '../../../../../../utils/form/extractFields'
import { emailRegex } from '../../../../../../utils/form/emailRegex'

const MFanMatchRegistration = ({ data }) => {
  const t = useTranslations()
  const formType = data.form_definition[0].identifier
  const fields = extractFields(data.form_definition[0].form_field)

  const selectPosition = {
    label: 'Position',
    id: 'position',
    values: [
      { id: 'position-option-1', name: 'Torwart' },
      { id: 'position-option-2', name: 'Abwehr' },
      { id: 'position-option-3', name: 'Mittelfeld' },
      { id: 'position-option-4', name: 'Sturm ' },
    ],
  }
  const selectStrength = {
    label: 'Spielstärke',
    id: 'skilllevel',
    values: [
      { id: 'strength-option-1', name: '1 (mäßig)' },
      { id: 'strength-option-2', name: '2' },
      { id: 'strength-option-3', name: '3' },
      { id: 'strength-option-4', name: '4' },
      { id: 'strength-option-5', name: '5 (sehr gut)' },
    ],
  }

  return (
    <MDefaultform
      buttonLabel="Anmeldung absenden"
      postUrl={process.env.FORM_API_URL}
      disableCaptcha={data.form_definition[0].captcha === 0}
      identifier={data.form_recipient[0].identifier}
      formType={formType}
    >
      {({ register, errors }) => (
        <>
          {data.headline && <DfbHeadline headline={data.headline} headline_level="h3" add_class="m-Formblock-headline" />}

          <div className="m-Formblock-spacer"></div>

          {fields.membernumber && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.membernumber.identifier, {
                  required: fields.membernumber.required === 1 ? t('form.errorMessage.input') : false,
                })}
                error={errors[fields.membernumber.identifier]}
                errorMessage={errors?.[fields.membernumber.identifier]?.message}
                label={`${fields.membernumber.label}${fields.membernumber.required === 1 ? '*' : ''}`}
                focused
              />
            </div>
          )}

          {(fields.firstname || fields.lastname || fields.dateofbirth) && (
            <div className="m-Formblock-row-third">
              {[fields.firstname, fields.lastname, fields.dateofbirth].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-row-third-cell" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                    focused
                  />
                </div>
              ))}
            </div>
          )}

          <div className="m-Formblock-spacer"></div>

          {fields.street && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.street.identifier, {
                  required: fields.street.required ? t('form.errorMessage.input') : false,
                })}
                error={errors[fields.street.identifier]}
                errorMessage={errors?.[fields.street.identifier]?.message}
                label={`${fields.street.label}${fields.street.required === 1 ? '*' : ''}`}
                focused
              />
            </div>
          )}

          {(fields.postcode || fields.location) && (
            <div className="m-Formblock-input-half">
              {[fields.postcode, fields.location].filter(Boolean).map((formItem) => (
                <div className="m-Formblock-input" key={formItem.label}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                      ...(formItem.identifier === 'postcode' && {
                        pattern: {
                          value: /^\d+$/,
                          message: t('form.errorMessage.postcodePattern'),
                        },
                      }),
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                    focused
                  />
                </div>
              ))}
            </div>
          )}

          {(fields.phone || fields.email) && (
            <div className="m-Formblock-input-half">
              {[fields.phone, fields.email].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-input" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                      pattern:
                        formItem.identifier === fields.email?.identifier
                          ? {
                              value: emailRegex,
                              message: t('form.errorMessage.emailPattern'),
                            }
                          : undefined,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                    focused
                  />
                </div>
              ))}
            </div>
          )}

          <div className="m-Formblock-spacer"></div>

          {fields.encounter && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.encounter.identifier, {
                  required: fields.encounter.required === 1 ? t('form.errorMessage.input') : false,
                })}
                error={errors[fields.encounter.identifier]}
                errorMessage={errors?.[fields.encounter.identifier]?.message}
                label={`${fields.encounter.label}${fields.encounter.required === 1 ? '*' : ''}`}
                focused
              />
            </div>
          )}
          {(selectPosition || selectStrength) && (
            <div className="m-Formblock-input-half">
              {[selectPosition, selectStrength].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-input" key={index}>
                  {formItem.values.length >= 2 && (
                    <DfbSelect
                      {...register(formItem.id, {
                        required: t('form.errorMessage.select'),
                      })}
                      label={formItem.label}
                      options={formItem.values.length >= 1 ? formItem.values : formItem.values[0]}
                      placeholder={t('form.placeholder.select')}
                      errorMessage={errors?.[formItem.id]?.message}
                      error={errors[formItem.id]}
                    />
                  )}
                </div>
              ))}
            </div>
          )}

          {fields.remark && (
            <div className="m-Formblock-input">
              <DfbInputTextarea
                {...register(fields.remark.identifier, {
                  required: fields.remark.required === 1 ? t('form.errorMessage.input') : false,
                })}
                label={`${fields.remark.label}${fields.remark.required === 1 ? '*' : ''}`}
                error={errors[fields.remark.identifier]}
                errorMessage={errors?.[fields.remark.identifier]?.message}
              />
            </div>
          )}

          <div className="m-Formblock-spacer"></div>

          <div className="m-Formblock-checkbox">
            <DfbParagraph text={t('form.privacyText')} />
          </div>
        </>
      )}
    </MDefaultform>
  )
}

export default MFanMatchRegistration
